import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { SESSION_LIMIT_FORMAT, STRATEGY_CARD_FORMAT, SVGPathMap, Utils } from '@app/_helpers';
import { ActiveSession } from '@app/modules/trading/modules/profile/components/personal-details/interfaces/personal-details.interfaces';

@Component({
  selector: 'app-active-session-limit-reached',
  templateUrl: './active-session-limit-reached.component.html',
  styleUrls: ['./active-session-limit-reached.component.scss']
})



export class ActiveSessionLimitReachedComponent implements OnInit {

  activeSessionLimitReachedImage = SVGPathMap.active_session_limit_reached;
  lastSessionDetails: ActiveSession = null;
  browserImage = SVGPathMap.browser;
  SESSION_LIMIT_FORMAT = SESSION_LIMIT_FORMAT;

  constructor(
    private dialog: MatDialogRef<ActiveSessionLimitReachedComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: {  activeSession: ActiveSession  },
  ) {
     this.lastSessionDetails = this.dialogData.activeSession;
   }

  ngOnInit(): void {
  }

  proceed() {
    this.dialog?.close(true);
  }

  cancel() {
    this.dialog?.close(false);
  }
}
